const transformAppCreatorAssets = (assetName) => `https://raw.githubusercontent.com/robotics-4-all/appcreator-documentation/refs/heads/main/assets/${assetName}`;

export default transformAppCreatorAssets;
